module.exports = __webpack_public_path__ + "static/media/pin-danger-viajes.f183b58b.png";